import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { ToastContainer, ToastStore } from "react-toasts";

import FullScreenMessageStyles from "./FullScreenMessage.css";

import utilities from "./Utilities";
let Utilities = new utilities();

window.requestSent = false;

export default class FullScreenMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      statusM: null,
      section: this.props.type,
      definitons: {}
    };
  }

  activateAccount = () => {
    this.setState({
      statusM: "Activation in Progress"
    });

    let url = window.location.href;
    let parts = url.split("/");

    if (
      Utilities.isENU(parts[parts.length - 1]) ||
      Utilities.isENU(parts[parts.length - 2])
    ) {
      this.setState({
        statusM: "Invalid credentials"
      });
    } else {
      this.setState({
        statusM: "Activation in progress"
      });

      window.globalVars.server.api({
        method: "post",
        url: "/api/user/activate",
        data: {
          id: parts[parts.length - 2],
          hash: parts[parts.length - 1]
        },
        then: function(res) {
          if (res.data.data !== undefined) {
            // this.setState({
            //     statusM: res.data.data
            // })

            ToastStore.success(res.data.data, 60000);
          }

          setTimeout(function() {
            window.location.href = "/login";
          }, 3000);
        }.bind(this),
        catch: function(e) {
          ToastStore.error("Error", 60000);

          setTimeout(function() {
            window.location.href = "/login";
          }, 3000);
        }.bind(this)
      });
    }
  };

  componentDidMount() {
    if (this.props.type === "activate-account") {
      if (!window.requestSent) {
        window.requestSent = true;
        this.activateAccount();
      }
    }
    let defintions = window.globalVars.definitons;
    let defintionsAssociative = {};

    if (!Utilities.isENU(defintions)) {
      for (var i = 0; i < defintions.length; i++) {
        let type = defintions[i].type;
        if (["checkout-message"].indexOf(type) !== -1) {
          defintionsAssociative[type] = defintions[i].valueStr;
        }
      }
    }

    this.setState({
      definitons: defintionsAssociative
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.section !== this.state.section) {
      this.setState(
        {
          section: nextProps.section
        },
        function() {
          if (this.state.section === "activate-account") {
            window.requestSent = true;
            this.activateAccount();
          }
        }
      );
    }
  }

  createCartItem = () => {
    window.location.href = "/build/size/" + Utilities.createCartItem();
  };

  render() {
    let id = window.location.href;
    let user;
    id = id.substr(id.lastIndexOf("/") + 1);

    return (
      <div className='full-screen-message-container'>
        <div className='main-container'>
          <div className='full-screen-message'>
            {this.state.section === "order-placed" ? (
              <div>
                <h1>
                  Thank you!
                  <br />
                  Your order has been placed.
                </h1>
                <p>
                  Your order number is <Link to={"/order/" + id}>{id}</Link>
                  {this.state.definitons["checkout-message"] ||
                    "We aim to deliver within 3-5 working days. You will receive an email notification to confirm delivery dispatch."}
                </p>
                <Link
                  className='main'
                  to='#'
                  onClick={() => {
                    this.createCartItem();
                  }}
                >
                  Continue Framing
                </Link>
              </div>
            ) : null}
            {this.state.section === "order-failed" ? (
              <div>
                <h1>
                  Opps!
                  <br />
                  We have failed to complete your order
                </h1>
                <Link className='main' to='/cart'>
                  Return to cart
                </Link>
              </div>
            ) : null}
            {this.state.section === "activate-account" ? (
              <div>
                <h1>{this.state.statusM}</h1>
                <Link className='main' to='/login'>
                  Login
                </Link>
              </div>
            ) : null}
          </div>
        </div>
        <ToastContainer
          store={ToastStore}
          position={ToastContainer.POSITION.TOP_CENTER}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FullScreenMessage.js